import ReportLink from './ReportLink.jsx';
export default ReportLink;